import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle, Circle } from "@phosphor-icons/react";

/**
 * Small toggleable badge showing invoicing status.
 * Click to toggle between "Fatturato" (green ✓) and "Da fatturare" (grey ○).
 * Purely visual — does NOT affect revenue stats.
 */
export default function InvoicedToggle({ intervention, onChange, size = "sm" }) {
  const [invoiced, setInvoiced] = useState(!!intervention.invoiced);
  const [busy, setBusy] = useState(false);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    const next = !invoiced;
    setBusy(true);
    // optimistic
    setInvoiced(next);
    try {
      const { data } = await api.patch(`/interventions/${intervention.id}`, { invoiced: next });
      onChange && onChange(data);
    } catch (err) {
      setInvoiced(!next);
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setBusy(false);
    }
  };

  const iconSize = size === "lg" ? 18 : 14;

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      data-testid={`invoiced-toggle-${intervention.code}`}
      title={invoiced ? "Fattura emessa – clicca per revocare" : "Da fatturare – clicca quando emetti la fattura"}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] font-mono uppercase tracking-widest border transition-colors ${
        invoiced
          ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30 hover:bg-emerald-500/25"
          : "bg-muted text-muted-foreground border-border hover:bg-secondary"
      } ${busy ? "opacity-60" : ""}`}
    >
      {invoiced ? <CheckCircle size={iconSize} weight="fill" /> : <Circle size={iconSize} />}
      {invoiced ? "Fatturato" : "Da fatturare"}
    </button>
  );
}
